import AppLink from "../AppLink";
import Text from "../Text";

const trackingBlockInfo = {
  block_name: "footer",
  block_row: "footer",
};

function LegalLink() {
  return (
    <div className="col-span-2 lg:col-span-4 pt-6 lg:pt-8 flex flex-wrap items-center justify-center mx-auto">
      <div className="px-2">
        <Text className="paragraph-small text-lapel">
          © {new Date().getFullYear()} Paperless Post ®
        </Text>
      </div>
      <div className="h-2.5 border-r border-lapel" />
      <div className="px-2">
        <AppLink
          href="/terms-of-service"
          className="paragraph-small text-lapel hover:text-black"
          tracking={{
            id: "paperless-post-terms-of-service",
            ...trackingBlockInfo,
          }}
        >
          Terms & Privacy
        </AppLink>
      </div>
      <div className="h-2.5 border-r border-lapel" />
      <div className="px-2">
        <AppLink
          href="/cookie-policy"
          className="paragraph-small text-lapel hover:text-black"
          tracking={{
            id: "paperless-post-cookie-policy",
            ...trackingBlockInfo,
          }}
        >
          Online Tracking Opt Out
        </AppLink>
      </div>
      <div className="h-2.5 border-r border-lapel" />
      <div className="px-2">
        <AppLink
          href="/accessibility-statement"
          className="paragraph-small text-lapel hover:text-black"
          tracking={{ id: "accessibility-statement", ...trackingBlockInfo }}
        >
          Accessibility Statement
        </AppLink>
      </div>
    </div>
  );
}

export default LegalLink;
